import { useAssetSettings } from './context/AssetSettingsContext';

export { AssetSettingsProvider, useAssetSettings } from './context/AssetSettingsContext';

export const useAssetsModuleVisible = (): boolean => {
  const { isModuleEnabled } = useAssetSettings();
  return isModuleEnabled;
};

